<template>
  <div class="bidding-plan-add-page">
    <div class="page-body">
      <el-form
        ref="form"
        :model="form"
        :rules="rulesEnabled ? rules : {}"
        label-width="160px"
        size="small"
        class="plan-form"
      >
        <div class="section-title">基本信息</div>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="招标项目名称" prop="projectName">
              <el-input v-model="form.projectName" placeholder="请输入招标项目名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招标计划公告类型" prop="planNoticeType">
              <el-select v-model="form.planNoticeType" placeholder="请选择招标计划公告类型" clearable style="width: 100%">
                <el-option
                  v-for="item in planNoticeTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="项目核准部门" prop="approvalDepartment">
              <el-input v-model="form.approvalDepartment" placeholder="请输入项目核准部门" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="核准文号" prop="approvalNumber">
              <el-input v-model="form.approvalNumber" placeholder="请输入核准文号" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="招标人(全称)" prop="bidderFullName">
              <el-input v-model="form.bidderFullName" placeholder="请输入招标人(全称)" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目所在行政区域" prop="adminRegion">
              <el-cascader
                ref="regionCascader"
                v-model="form.adminRegion"
                placeholder="请选择项目所在行政区域"
                :props="regionCascaderProps"
                @change="handleRegionChange"
                style="width: 100%"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="项目行业" prop="industry">
              <el-cascader
                ref="industryCascader"
                v-model="form.industry"
                placeholder="请选择项目行业"
                :props="industryCascaderProps"
                @change="handleIndustryChange"
                style="width: 100%"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目总投资(万元)" prop="totalInvestment">
              <el-input-number v-model="form.totalInvestment" :min="0" :controls="true" style="width: 100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="招标估算额(万元)" prop="estimatedAmount">
              <el-input-number v-model="form.estimatedAmount" :min="0" :controls="true" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预发布招标公告时间" prop="preAnnouncementTime">
              <app-date-picker
                v-model="form.preAnnouncementTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择时间"
                style="width: 100%"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label="资金来源" prop="fundingSource">
              <el-input
                v-model="form.fundingSource"
                type="textarea"
                :rows="3"
                maxlength="500"
                show-word-limit
                placeholder="请输入资金来源"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label="招标项目概况" prop="projectOverview">
              <el-input
                v-model="form.projectOverview"
                type="textarea"
                :rows="3"
                maxlength="500"
                show-word-limit
                placeholder="请输入招标项目概况"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label="招标内容与范围" prop="contentAndScope">
              <el-input
                v-model="form.contentAndScope"
                type="textarea"
                :rows="3"
                maxlength="500"
                show-word-limit
                placeholder="请输入招标内容与范围"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="拟采用招标方式" prop="bidMethod">
              <el-radio-group v-model="form.bidMethod">
                <el-radio :label="1">公开招标</el-radio>
                <el-radio :label="2">邀请招标</el-radio>
                <el-radio :label="3">其他</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="拟采用招标组织方式" prop="organizationMethod">
              <el-radio-group v-model="form.organizationMethod">
                <el-radio :label="1">自行招标</el-radio>
                <el-radio :label="2">委托招标</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="预发布招标公告媒介" prop="preAnnouncementPlatform">
              <el-radio-group v-model="form.preAnnouncementPlatform">
                <el-radio :label="1">河北省招标投标公共服务平台</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.organizationMethod === 2">
            <el-form-item label="招标代理机构(全称)" prop="delegateAgencyName">
              <el-input v-model="form.delegateAgencyName" placeholder="请输入拟委托的招标代理机构(全称)" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="section-title">联系方式</div>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="联系人所属招标人全称" prop="contactName">
              <el-input v-model="form.contactName" placeholder="请输入联系人所属招标人全称" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址" prop="contactAddress">
              <el-input v-model="form.contactAddress" placeholder="请输入地址" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input v-model="form.contactPhone" placeholder="请输入联系电话" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input v-model="form.contactPerson" placeholder="请输入联系人" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="电子邮件" prop="contactEmail">
              <el-input v-model="form.contactEmail" placeholder="请输入电子邮件" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="section-title">附件</div>
        <el-form-item label="附件" prop="attachments" class="attachment-item">
          <ChunkUploader
            ref="uploader"
            :file-bind-id="attachmentBindId"
            :maxFileSize="10"
            :multiple="true"
            :autoUpload="true"
            :fileBindId="fileGuid"
            buttonText="选择附件"
            @upload-success="handleUploadSuccess"
            @file-removed="handleFileRemoved"
          />
          <div class="tips">附件非必传，单个文件不超过10MB</div>
        </el-form-item>
      </el-form>
    </div>
    <div class="page-footer">
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit('submit')">提交</el-button>
      <el-button :loading="submitLoading" @click="handleSubmit('draft')">暂存</el-button>
      <el-button @click="handleCancel">取消</el-button>
    </div>
  </div>
</template>
<script>
import RegionUtils from '@/utils/regionUtils'
import ChunkUploader from '@/components/common/ChunkUploader.vue'
import { addBuildPlan } from '@/api/agent/api'
export default {
  name: 'BiddingPlanAdd',
  components: {
    ChunkUploader
  },
  data() {
    const validateDelegateAgency = (rule, value, callback) => {
      if (this.form.organizationMethod === 2 && (!value || !String(value).trim())) {
        callback(new Error('请输入拟委托的招标代理机构(全称)'))
        return
      }
      callback()
    }
    return {
      fileGuid:'',
      submitLoading: false,
      rulesEnabled: false,
      attachmentBindId: String(Date.now()) + Math.random().toString().slice(2, 8),
      planNoticeTypeOptions: [
        { label: '招标计划', value: 0 },
        { label: '其他', value: 1 }
      ],
      form: {
        projectName: '',
        planNoticeType: '',
        approvalDepartment: '',
        approvalNumber: '',
        bidderFullName: '',
        adminRegion: [],
        provinceCode: '',
        cityCode: '',
        areaCode: '',
        industry: '',
        fundingSource: '',
        totalInvestment: null,
        estimatedAmount: null,
        bidMethod: null,
        organizationMethod: null,
        projectOverview: '',
        contentAndScope: '',
        preAnnouncementTime: '',
        preAnnouncementPlatform: null,
        contactName: '',
        contactAddress: '',
        contactPhone: '',
        contactPerson: '',
        contactEmail: '',
        delegateAgencyName: '',
        fileBindId: '',
        planStatus: null
      },
      rules: {
        projectName: [{ required: true, message: '请输入招标项目名称' }],
        planNoticeType: [{ required: true, message: '请选择招标计划公告类型' }],
        approvalDepartment: [{ required: true, message: '请输入项目核准部门' }],
        approvalNumber: [{ required: true, message: '请输入核准文号' }],
        bidderFullName: [{ required: true, message: '请输入招标人(全称)' }],
        adminRegion: [{ type: 'array', required: true, message: '请选择项目所在行政区域' }],
        industry: [{ required: true, message: '请选择项目行业' }],
        fundingSource: [{ required: true, message: '请输入资金来源' }],
        totalInvestment: [{ required: true, message: '请输入项目总投资(万元)' }],
        estimatedAmount: [{ required: true, message: '请输入招标估算额(万元)' }],
        bidMethod: [{ required: true, message: '请选择拟采用招标方式' }],
        organizationMethod: [{ required: true, message: '请选择拟采用招标组织方式' }],
        projectOverview: [{ required: true, message: '请输入招标项目概况' }],
        contentAndScope: [{ required: true, message: '请输入招标内容与范围' }],
        preAnnouncementTime: [{ required: true, message: '请选择预发布招标公告时间' }],
        preAnnouncementPlatform: [{ required: true, message: '请选择预发布招标公告媒介' }],
        contactName: [{ required: true, message: '请输入联系人所属招标人全称' }],
        contactAddress: [{ required: true, message: '请输入地址' }],
        contactPhone: [{ required: true, message: '请输入联系电话' }],
        contactPerson: [{ required: true, message: '请输入联系人' }],
        contactEmail: [
          { required: true, message: '请输入电子邮件' },
          { type: 'email', message: '请输入正确的电子邮件格式' }
        ],
        delegateAgencyName: [{ validator: validateDelegateAgency, trigger: 'blur' }]
      }
    }
  },
  watch: {
    'form.organizationMethod'(val) {
      if (val !== 2) {
        this.form.delegateAgencyName = ''
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate(['delegateAgencyName'])
          }
        })
      }
    }
  },
  computed: {
    regionCascaderProps() {
      return RegionUtils.getCascaderProps()
    },
    industryCascaderProps() {
      return RegionUtils.getCascaderProps('COMPANY_INDUSTRY_CODE')
    }
  },
  mounted() {
      this.fileGuid = new Date().getTime() + Math.random().toString().substr(2, 5)
    RegionUtils.initRegionFields(this.form)
    RegionUtils.initRegionFields(this.form, {
      provinceField: 'industryLevel1',
      provinceCodeField: 'industryLevel1Code',
      cityField: 'industryLevel2',
      cityCodeField: 'industryLevel2Code',
      countyField: 'industryLevel3',
      countyCodeField: 'industryLevel3Code',
      regionField: 'industry'
    })
  },
  methods: {
    async handleRegionChange(value) {
      await RegionUtils.handleRegionChange(
        value,
        this.$refs.regionCascader,
        this.form,
        { enableDebug: false },
        this,
        'REGION_CODE'
      )
      // areaCode 是最后选中的区县编码
      if (value && value.length > 0) {
        this.form.areaCode = value[value.length - 1]
      } else {
        this.form.areaCode = ''
      }
    },
    async handleIndustryChange(value) {
      await RegionUtils.handleRegionChange(
        value,
        this.$refs.industryCascader,
        this.form,
        {
          enableDebug: false,
          provinceField: 'industryLevel1',
          provinceCodeField: 'industryLevel1Code',
          cityField: 'industryLevel2',
          cityCodeField: 'industryLevel2Code',
          countyField: 'industryLevel3',
          countyCodeField: 'industryLevel3Code',
          regionField: 'industry'
        },
        this,
        'COMPANY_INDUSTRY_CODE'
      )
    },
    handleUploadSuccess() {
      this.syncAttachments()
    },
    handleFileRemoved() {
      this.syncAttachments()
    },
    syncAttachments() {
      const uploader = this.$refs.uploader
      if (!uploader || typeof uploader.getCompletedFiles !== 'function') {
        this.form.attachments = []
        return
      }
      this.form.attachments = uploader.getCompletedFiles().map(item => ({
        fileName: item.fileName,
        fileUrl: item.fileUrl,
        fileId: item.fileId,
        uploadId: item.uploadId
      }))
    },
    async handleSubmit(action) {
      if (this.submitLoading) return
      const uploader = this.$refs.uploader
      if (uploader && typeof uploader.getUploadingFiles === 'function') {
        const uploading = uploader.getUploadingFiles()
        if (uploading && uploading.length > 0) {
          this.$message.warning('附件正在上传中，请稍后再提交')
          return
        }
      }
      this.syncAttachments()

      this.submitLoading = true
      try {
        this.rulesEnabled = true
        await this.$nextTick()
        const valid = await new Promise(resolve => {
          this.$refs.form.validate(ok => resolve(ok))
        })
        if (!valid) return

        const payload = {
          projectName: this.form.projectName,
          approvalDepartment: this.form.approvalDepartment,
          approvalNumber: this.form.approvalNumber,
          bidderFullName: this.form.bidderFullName,
          provinceCode: this.form.provinceCode,
          cityCode: this.form.cityCode,
          areaCode: this.form.areaCode,
          industry: this.form.industry,
          totalInvestment: this.form.totalInvestment,
          estimatedAmount: this.form.estimatedAmount,
          fundingSource: this.form.fundingSource,
          projectOverview: this.form.projectOverview,
          contentAndScope: this.form.contentAndScope,
          bidMethod: this.form.bidMethod,
          organizationMethod: this.form.organizationMethod,
          preAnnouncementTime: this.form.preAnnouncementTime,
          preAnnouncementPlatform: this.form.preAnnouncementPlatform,
          contactName: this.form.contactName,
          contactAddress: this.form.contactAddress,
          contactPhone: this.form.contactPhone,
          contactPerson: this.form.contactPerson,
          contactEmail: this.form.contactEmail,
          fileBindId: this.fileGuid,
          planStatus: action === 'submit' ? 2 : 1
        }

        const res = await addBuildPlan(payload)
        if (res.code === 200) {
          this.$message.success(action === 'submit' ? '提交成功' : '暂存成功')
          this.$router.go(-1)
        } else {
          this.$message.error(res.msg || (action === 'submit' ? '提交失败' : '暂存失败'))
        }
      } catch (error) {
        this.$message.error('操作失败，请稍后重试')
      } finally {
        this.submitLoading = false
      }
    },
    handleCancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.bidding-plan-add-page {
  padding: 16px;
}

.page-body {
  background: #fff;
  border: 1px solid #ebeef5;
  padding: 16px;
}

.section-title {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  padding: 8px 0;
  margin: 8px 0 12px 0;
  border-bottom: 1px solid #ebeef5;
}

.plan-form ::v-deep .el-form-item {
  margin-bottom: 14px;
}

.attachment-item {
  margin-bottom: 0;
}

.tips {
  color: #909399;
  font-size: 12px;
  margin-top: 6px;
}

.page-footer {
  background: #fff;
  border: 1px solid #ebeef5;
  border-top: 0;
  padding: 12px 16px;
  display: flex;
  justify-content: center;
  gap: 12px;
}
</style>